import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="container py-12 mx-auto">
      <div className="max-w-4xl mx-auto">
        <h1 className="mb-8 text-4xl font-bold text-center text-secondary-900">Privacy Policy</h1>
        
        <div className="prose prose-lg max-w-none">
          <p className="mb-6">
            Last updated: August 22, 2025
          </p>
          
          <h2 className="mt-8 mb-4 text-2xl font-semibold">1. Introduction</h2>
          <p>
            FutureSoft Technologies ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
          </p>
          <p>
            Please read this Privacy Policy carefully. If you do not agree with the terms of this Privacy Policy, please do not access the site.
          </p>
          
          <h2 className="mt-8 mb-4 text-2xl font-semibold">2. Information We Collect</h2>
          <h3 className="mt-6 mb-3 text-xl font-semibold">Personal Information</h3>
          <p>
            We may collect personal information that you voluntarily provide to us when you:
          </p>
          <ul className="ml-6 mb-6 list-disc">
            <li>Fill out forms on our website</li>
            <li>Register for an account</li>
            <li>Subscribe to our newsletter</li>
            <li>Request information or assistance</li>
            <li>Participate in contests or surveys</li>
            <li>Contact us directly</li>
          </ul>
          <p>
            This information may include your name, email address, phone number, company name, and job title.
          </p>
          
          <h3 className="mt-6 mb-3 text-xl font-semibold">Automatically Collected Information</h3>
          <p>
            When you visit our website, we may automatically collect certain information about your device, including:
          </p>
          <ul className="ml-6 mb-6 list-disc">
            <li>IP address</li>
            <li>Browser type and version</li>
            <li>Operating system</li>
            <li>Referring website</li>
            <li>Pages you view</li>
            <li>Time and date of your visit</li>
          </ul>
          
          <h2 className="mt-8 mb-4 text-2xl font-semibold">3. How We Use Your Information</h2>
          <p>
            We may use the information we collect for various purposes, including:
          </p>
          <ul className="ml-6 mb-6 list-disc">
            <li>Providing and maintaining our services</li>
            <li>Improving our website and services</li>
            <li>Communicating with you about our services</li>
            <li>Responding to your inquiries and requests</li>
            <li>Sending you marketing and promotional materials</li>
            <li>Analyzing usage patterns and trends</li>
            <li>Protecting against unauthorized access</li>
          </ul>
          
          <h2 className="mt-8 mb-4 text-2xl font-semibold">4. Cookies and Similar Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to collect information about your browsing activities. Cookies are small text files stored on your device that help us provide you with a better browsing experience.
          </p>
          <p>
            You can set your browser to refuse all or some browser cookies or to alert you when websites set or access cookies. If you disable or refuse cookies, please note that some parts of this website may become inaccessible or not function properly.
          </p>
          
          <h2 className="mt-8 mb-4 text-2xl font-semibold">5. Data Security</h2>
          <p>
            We have implemented appropriate technical and organizational security measures to protect your personal information from accidental loss, unauthorized access, use, alteration, and disclosure. However, please note that no method of transmission over the Internet or electronic storage is 100% secure.
          </p>
          
          <h2 className="mt-8 mb-4 text-2xl font-semibold">6. Third-Party Disclosure</h2>
          <p>
            We may share your information with:
          </p>
          <ul className="ml-6 mb-6 list-disc">
            <li>Service providers who perform services on our behalf</li>
            <li>Business partners with whom we jointly offer products or services</li>
            <li>Affiliated companies within our corporate family</li>
            <li>Legal authorities when required by law</li>
          </ul>
          
          <h2 className="mt-8 mb-4 text-2xl font-semibold">7. Your Rights</h2>
          <p>
            Depending on your location, you may have certain rights regarding your personal information, including:
          </p>
          <ul className="ml-6 mb-6 list-disc">
            <li>The right to access your personal information</li>
            <li>The right to correct inaccurate information</li>
            <li>The right to request deletion of your information</li>
            <li>The right to restrict or object to processing</li>
            <li>The right to data portability</li>
          </ul>
          <p>
            To exercise these rights, please contact us using the information provided below.
          </p>
          
          <h2 className="mt-8 mb-4 text-2xl font-semibold">8. Children's Privacy</h2>
          <p>
            Our services are not intended for individuals under the age of 16. We do not knowingly collect personal information from children under 16. If you are a parent or guardian and believe your child has provided us with personal information, please contact us.
          </p>
          
          <h2 className="mt-8 mb-4 text-2xl font-semibold">9. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last updated" date.
          </p>
          <p>
            You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.
          </p>
          
          <h2 className="mt-8 mb-4 text-2xl font-semibold">10. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p className="mb-6">
            Email: privacy@futuresoft.tech<br />
            Phone: +91 9455544334<br />
            Address: 12, Block C8, 1st Floor, Sector 18, Vrindavan yojna, Lucknow, Uttar Pradesh
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
